import { EventComplete } from 'bff';
import { Activity } from './Activity';
import es from 'date-fns/locale/es';
import { customFormatDistance } from 'utils';
import { cn, ScrollArea } from 'ui';

// Mirrors the insurer's ClaimActivity/ActivityTab layout: a scroll area pinned to
// the bottom (events arrive oldest-first, so the newest sits at the end), no
// per-event marker icons, and the avatar + action + time-ago item alignment.
export const ActivityEventsList = ({
  events,
  className,
  path,
}: {
  events: EventComplete[];
  className?: string;
  /** The claim detail path the events link from (e.g. an offer event → `${path}/offers`). */
  path?: string;
}) => {
  return (
    <div className='bg-white'>
      <ScrollArea
        orientation='vertical'
        className={cn('flex flex-col max-h-[60vh] w-full', className)}
        scrollToBottom
      >
        <Activity className='bg-white'>
          {events.map((event, index) => (
            <Activity.Item
              index={index}
              event={event}
              eventsCount={events.length}
              key={event.id}
            >
              <Activity.Content className='bg-white'>
                <Activity.Header eventType={event.type}>
                  <Activity.TriggeredInfo event={event} path={path} />
                  <Activity.TimeAgo className='mt-0'>
                    <span className='text-end'>
                      {customFormatDistance(
                        new Date(),
                        new Date(event.created_at),
                        {
                          locale: es,
                          justDate: true,
                        },
                      )}
                    </span>
                    <span className='text-stone-400 text-end'>
                      {customFormatDistance(
                        new Date(),
                        new Date(event.created_at),
                        {
                          locale: es,
                          justSuffix: true,
                        },
                      )}
                    </span>
                  </Activity.TimeAgo>
                </Activity.Header>
              </Activity.Content>
            </Activity.Item>
          ))}
        </Activity>
      </ScrollArea>
    </div>
  );
};
